import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getCategoryByQuery,
  getCategoryBySlug,
} from "../config/navigation";

const SEOContext = createContext();

export const SEOProvider = ({ children }) => {
  const [categoryName, setCategoryName] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (
      !location.pathname.startsWith("/products") &&
      !location.pathname.startsWith("/category")
    ) {
      setCategoryName(null);
      return;
    }

    const categoryFromQuery = new URLSearchParams(location.search).get(
      "category",
    );
    const queryCategory = categoryFromQuery
      ? getCategoryByQuery(categoryFromQuery)
      : null;

    const categorySlug = location.pathname.match(
      /^\/(?:products\/category|category)\/([^/]+)/,
    )?.[1];
    const routeCategory = categorySlug ? getCategoryBySlug(categorySlug) : null;

    setCategoryName((queryCategory || routeCategory)?.query || null);
  }, [location.pathname, location.search]);

  return (
    <SEOContext.Provider value={{ categoryName, setCategoryName }}>
      {children}
    </SEOContext.Provider>
  );
};

export const useSEO = () => useContext(SEOContext);
